const {registerBlockType} = wp.blocks;
const {Component} = wp.element;
const {RichText, InspectorControls, PanelColorSettings, FontSizePicker}  = wp.blockEditor;
import { PanelBody, ToggleControl, BaseControl, SelectControl, TextControl, RangeControl, __experimentalBoxControl as BoxControl, __experimentalBorderBoxControl as BorderBoxControl} from '@wordpress/components';
const {__} = wp.i18n;
import FontPicker from "./lib/FontPicker.js";

const addNewTimeLine = {
    title: __('Registration','spice-blocks'),
    description: __('Lorem ipsum dolor sit consectetur amet tempora enim edipising impedit dolor','spice-blocks'),
    dateTime: `10:00${__('AM','spice-blocks')}-11:00${__('AM','spice-blocks')}`,
    year: '2023'
};

const defaultTimeLine = JSON.stringify([
    {
        title: __('Registration','spice-blocks'),
        description: __('Lorem ipsum dolor sit consectetur amet tempora enim edipising impedit dolor','spice-blocks'),
        dateTime: `10:00${__('AM','spice-blocks')}-11:00${__('AM','spice-blocks')}`,
        year: '2023'
    },
    {
        title: __('Presentation','spice-blocks'),
        description: __('Lorem ipsum dolor sit consectetur amet tempora enim edipising imedit dolor','spice-blocks'),
        dateTime: `11:00${__('AM','spice-blocks')}-12:00${__('PM','spice-blocks')}`,
        year: '2023'
    },
    {
        title: __('Lunch','spice-blocks'),
        description: __('Lorem ipsum dolor sit consectetur amet tempora enim edipising imedit dolor','spice-blocks'),
        dateTime: `12:00${__('PM','spice-blocks')}-1:00${__('PM','spice-blocks')}`,
        year: '2023'
    },
    {
        title: __('Meeting','spice-blocks'),
        description: __('Lorem ipsum dolor sit consectetur amet tempora enim edipising imedit dolor','spice-blocks'),
        dateTime: `1:00${__('PM','spice-blocks')}-3:00${__('PM','spice-blocks')}`,
        year: '2023'
    },
    {
        title: __('Dinner','spice-blocks'),
        description: __('Lorem cipsum dolor sit consectetur amet tempora enim edipising imedit dolor','spice-blocks'),
        dateTime: `7:00${__('PM','spice-blocks')}-9:00${__('PM','spice-blocks')}`,
        year: '2023'
    }
]);

class Edit extends Component{
    SpiceAppendTimeline = () => {
        this.props.setAttributes({
            items: [...this.props.attributes.items,            
                { ...addNewTimeLine }],
        });
    };

    SpiceRemoveTimeline = (index) => {
        const items = [ ...this.props.attributes.items ];
        if ( items.length === 1 ) {
            this.props.setAttributes( { items: [ addNewTimeLine ] } );
        } else {
            items.splice( index, 1 );
            this.props.setAttributes( { items: items } );
        } 
    };
    SpiceOnLoadTimelineValue = ( property, value, index, bool = false ) => {
        const items = [...this.props.attributes.items];
        items[ index ][ property ] = value;
        this.props.setAttributes( { items: items } );
    };

    render()
    {
        const { className, attributes, setAttributes, isSelected, clientId} = this.props;
        const { uniqueId, hoverAnimation, TimelineAnimation, TimelineDurations, TimelineDelay, enableTimelineTitle, enableTimelineContent, enableTimelineYr, enableTimelineTime, TimelineSectionOuterPaddings, TimelineSectionInnerPaddings, TimelineTitlePaddings, TimelineContentPaddings, TimelineYearPaddings, paddings, timelinebgColor, titleColor, contentColor, yearbgColor, yearColor, timeColor, fontfamily, titlefontSize, TitleFontWeight, TitleLineHeight, TitleTransform, TitleDecoration, TitleLetterSpacing, TimelineContentfontfamily, TimelinecontentfontSize, TimelineContentFontWeight, TimelineContentLineHeight, TimelineContentTextTransform, TimelineContentTextDecoration, TimelineContentLetterSpacing, TimelinDateFontFamily, TimelineDateFontSize, TimelineDateFontWeight, TimelineDateLineHeight, TimelineDateTextTransform, TimelineDateTextDecoration, TimelineDateLetterSpacing, TimelineTimeFontFamily, TimelineTimeFontSize, TimelineTimeFontWeight, TimelineTimeLineHeight, TimelineTimeTransform, TimelineTimeDecoration, TimelineTimeLetterSpacing, TimelineHideDesktop, TimelineHideTablet, TimelineHideMobile, TimelineConnector, TimelineConnectorCircle, TimelineConnectorCircleSize, hshadow, vshadow, blurshadow, shadowColor } = attributes;

        // Connector Line Border
        const TimelineConnectortop=(TimelineConnector.top != undefined) ? `${TimelineConnector.top.width} ${TimelineConnector.top.style} ${TimelineConnector.top.color}` : null;
	    const TimelineConnectoright=(TimelineConnector.right != undefined) ? `${TimelineConnector.right.width} ${TimelineConnector.right.style} ${TimelineConnector.right.color}` : null;
	    const TimelineConnectorbottom=(TimelineConnector.bottom != undefined) ? `${TimelineConnector.bottom.width} ${TimelineConnector.bottom.style} ${TimelineConnector.bottom.color}` : null;
	    const TimelineConnectorleft=(TimelineConnector.left != undefined) ? `${TimelineConnector.left.width} ${TimelineConnector.left.style} ${TimelineConnector.left.color}` : null;

        // Connector Circle Border
        const TimelineConnectorCircleortop=(TimelineConnectorCircle.top != undefined) ? `${TimelineConnectorCircle.top.width} ${TimelineConnectorCircle.top.style} ${TimelineConnectorCircle.top.color}` : null;
	    const TimelineConnectorCircleright=(TimelineConnectorCircle.right != undefined) ? `${TimelineConnectorCircle.right.width} ${TimelineConnectorCircle.right.style} ${TimelineConnectorCircle.right.color}` : null;
	    const TimelineConnectorCirclebottom=(TimelineConnectorCircle.bottom != undefined) ? `${TimelineConnectorCircle.bottom.width} ${TimelineConnectorCircle.bottom.style} ${TimelineConnectorCircle.bottom.color}` : null;
	    const TimelineConnectorCircleleft=(TimelineConnectorCircle.left != undefined) ? `${TimelineConnectorCircle.left.width} ${TimelineConnectorCircle.left.style} ${TimelineConnectorCircle.left.color}` : null;

         // set unique ID
        setAttributes({ uniqueId: clientId.slice(0, 8), }); 
        const animationclass='animated ' +attributes.TimelineDurations+' '+attributes.TimelineAnimation; 
        const displaydesktop=(TimelineHideDesktop == false) ? 'hide-desktop' : '';
        const displaytablet=(TimelineHideTablet == false) ? 'hide-tablet' : '';
        const displaymobile=(TimelineHideMobile == false) ? 'hide-mobile' : '';
        const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
       
        if(fontfamily !=null){
            let url = 'https://fonts.googleapis.com/css2?family='+fontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
             let link = document.createElement('link')
              link.href = url;
              link.rel = "stylesheet";
              link.type =  "text/css";
              
              if ( jQuery("body").hasClass("site-editor-php") ) { 
              jQuery('iframe').contents().find("head").append(link);
          }else{
              document.head.appendChild(link);
          }
        }
        if(TimelineContentfontfamily !=null){
            let url2 = 'https://fonts.googleapis.com/css2?family='+TimelineContentfontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
             let link = document.createElement('link')
              link.href = url2;
              link.rel = "stylesheet";
              link.type =  "text/css";
              
              if ( jQuery("body").hasClass("site-editor-php") ) { 
              jQuery('iframe').contents().find("head").append(link);
          }else{
              document.head.appendChild(link);
          }
        }
        if(TimelinDateFontFamily !=null){
            let url3 = 'https://fonts.googleapis.com/css2?family='+TimelinDateFontFamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
             let link = document.createElement('link')
              link.href = url3;
              link.rel = "stylesheet";
              link.type =  "text/css";
              
              if ( jQuery("body").hasClass("site-editor-php") ) { 
              jQuery('iframe').contents().find("head").append(link);
          }else{
              document.head.appendChild(link);
          }
        }
        if(TimelineTimeFontFamily !=null){
            let url4 = 'https://fonts.googleapis.com/css2?family='+TimelineTimeFontFamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
             let link = document.createElement('link')
              link.href = url4;
              link.rel = "stylesheet";
              link.type =  "text/css";
              
              if ( jQuery("body").hasClass("site-editor-php") ) { 
              jQuery('iframe').contents().find("head").append(link);
          }else{
              document.head.appendChild(link);
          }
        }
        
        return([
            <>
            <InspectorControls>
                <PanelBody initialOpen={true} title={__('General Settings','spice-blocks')}>    
                    <PanelBody initialOpen={false} title={__('Section','spice-blocks')} className={'spice-panel-edit margin'}>
                        <BoxControl 
                            label={__('Section Outer Padding','spice-blocks')}
                            values={TimelineSectionOuterPaddings}
                            sides={['top', 'bottom','left','right']}
                            allowReset={false}
                            inputProps={{ min: -300 }}
                            units={[]}
                            onChange={(userVal) => setAttributes({
                                TimelineSectionOuterPaddings:{
                                    top:userVal.top,
                                    right:userVal.right,
                                    bottom:userVal.bottom,
                                    left:userVal.left
                                }
                            })}
                        /> 
                        <BoxControl 
                            label={__('Section Inner Padding','spice-blocks')}
                            values={TimelineSectionInnerPaddings}
                            sides={['top', 'bottom','left','right']}
                            allowReset={false}
                            units={[]}
                            onChange={(userVal) => setAttributes({
                                TimelineSectionInnerPaddings:{
                                    top:userVal.top,
                                    right:userVal.right,
                                    bottom:userVal.bottom,
                                    left:userVal.left
                                }
                            })}
                        />
                    </PanelBody>   
                    <PanelBody initialOpen={false} title={__('Title','spice-blocks')} className={'spice-panel-edit margin'}>
                        <ToggleControl
                            label={__('Enable/Disable Title','spice-blocks')}
                            checked={enableTimelineTitle}
                            onChange={() => setAttributes({ enableTimelineTitle: !enableTimelineTitle })}    
                        />
                        { enableTimelineTitle && [<>
                            <BoxControl 
                                label={__('Title Padding','spice-blocks')}
                                values={TimelineTitlePaddings}
                                sides={['top', 'bottom','left','right']}
                                allowReset={false}
                                units={[]}
                                onChange={(userVal) => setAttributes({
                                    TimelineTitlePaddings:{
                                        top:userVal.top,
                                        right:userVal.right,
                                        bottom:userVal.bottom,
                                        left:userVal.left
                                    }
                                    })}
                            /> 
                        </>]}
                    </PanelBody>
                    <PanelBody initialOpen={false} title={__('Content','spice-blocks')} className={'spice-panel-edit margin'}>
                        <ToggleControl
                                label={__('Enable/Disable Content','spice-blocks')}
                                checked={enableTimelineContent}
                                onChange={() => setAttributes({ enableTimelineContent: !enableTimelineContent })}    
                        />
                        { enableTimelineContent && [<>
                        <BoxControl 
						label={__('Content Padding','spice-blocks')}
						values={TimelineContentPaddings}
                        sides={['top', 'bottom','left','right']}
						allowReset={false}
						units={[]}
						onChange={(userVal) => setAttributes({
							TimelineContentPaddings:{
								top:userVal.top,
								right:userVal.right,
								bottom:userVal.bottom,
								left:userVal.left
							}
                            })}
                        /> 
                        </>]}
                    </PanelBody>
                    <PanelBody initialOpen={false} title={__('Year','spice-blocks')} className={'spice-panel-edit margin'}>
                        <ToggleControl
                            label={__('Enable/Disable Year/Date','spice-blocks')}
                            checked={enableTimelineYr}
                            onChange={() => setAttributes({ enableTimelineYr: !enableTimelineYr })}    
                        />
                        { enableTimelineYr && [<>
                            <BoxControl 
                                label={__('Year Padding','spice-blocks')}
                                values={TimelineYearPaddings}
                                sides={['top', 'bottom','left','right']}
                                allowReset={false}
                                units={[]}
                                onChange={(userVal) => setAttributes({
                                    TimelineYearPaddings:{
                                        top:userVal.top,
                                        right:userVal.right,
                                        bottom:userVal.bottom,
                                        left:userVal.left
                                    }
                                    })}
                            /> 
                        </>]}
                    </PanelBody>
                    <PanelBody initialOpen={false} title={__('Time','spice-blocks')} className={'spice-panel-edit margin'}>
                        <ToggleControl
                            label={__('Enable/Disable Time','spice-blocks')}
                            checked={enableTimelineTime}
                            onChange={() => setAttributes({ enableTimelineTime: !enableTimelineTime })}    
                        />
                        { enableTimelineTime && [<>
                            <BoxControl 
                            label={__('Time Padding','spice-blocks')}
                            values={paddings}
                            sides={['top', 'bottom','left','right']}
                            allowReset={false}
                            units={[]}
                            onChange={(userVal) => setAttributes({
                                paddings:{
                                    top:userVal.top,
                                    right:userVal.right,
                                    bottom:userVal.bottom,
                                    left:userVal.left
                                }
                                })}
                            />
                        </>]}
                    </PanelBody>
                    <PanelBody initialOpen={false} title={__('Animation Effect','spice-blocks')} className={'spice-panel-edit margin'}>
                        <ToggleControl
                            label={__('Enable/Disable Hover','spice-blocks')}
                            checked={hoverAnimation}
                            onChange={() => setAttributes({ hoverAnimation: !hoverAnimation })}    
                        />
                        <SelectControl
                            label={__('Animation','spice-block-plus')}
                            value={ TimelineAnimation }
                            options={ [
                                { label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' }
                            ] }
                            onChange={ (userVal) => setAttributes({ TimelineAnimation: userVal }) }					  
                        />  
                        { TimelineAnimation != '' && ( 
                        <>
                        <SelectControl
                            label={__('Durations','spice-block-plus')}
                            value={ TimelineDurations }
                            options={ [
                                { label: __('Normal','spice-blocks'), value: ' ' },
                                { label: __('Slow','spice-blocks'), value: 'slow' },
                                { label: __('Fast','spice-blocks'), value: 'fast' },
                            ] }
                            onChange={ (userVal) => setAttributes({ TimelineDurations: userVal }) }					  
                        />  
                        <TextControl
                            label={__('Delay(ms)','spice-block-plus')}			    
                            value={TimelineDelay}
                            onChange={(userVal) => setAttributes({ TimelineDelay: userVal })}
                        />
                        </>)} 
                    </PanelBody>
                    <PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit margin'}>					
                        <ToggleControl
                            label={__('Enable/Disable on Desktop','spice-blocks')}
                            checked={TimelineHideDesktop}
                            onChange={(userVal) => setAttributes({ TimelineHideDesktop: userVal })}
                        />
                        <ToggleControl
                            label={__('Enable/Disable on Tablet','spice-blocks')}
                            checked={TimelineHideTablet}
                            onChange={(userVal) => setAttributes({ TimelineHideTablet: userVal })}
                        />
                        <ToggleControl
                            label={__('Enable/Disable on Mobile','spice-blocks')}
                            checked={TimelineHideMobile}
                            onChange={(userVal) => setAttributes({ TimelineHideMobile: userVal })}
                        />
                    </PanelBody>
                </PanelBody>

                <PanelBody initialOpen={false} title={__('Connector Settings','spice-blocks')} className={'spice-block-side-margin'}>
                    <BorderBoxControl 
						label={__('Connector', 'spice-blocks')}
						value={TimelineConnector}
						onChange={(userVal) => setAttributes({TimelineConnector:userVal})}
					/>
                    <BorderBoxControl 
						label={__('Circle', 'spice-blocks')}
						value={TimelineConnectorCircle}
						onChange={(userVal) => setAttributes({TimelineConnectorCircle:userVal})}
					/>
                    <RangeControl 
                        label={__('Circle Size(px)','spice-blocks')}
                        value={TimelineConnectorCircleSize}
                        min={0}
                        max={100}
                        onChange={(userVal) => setAttributes({TimelineConnectorCircleSize: userVal})}
                    />
                </PanelBody>

                <PanelBody initialOpen={false} title={__('Box Shadow','spice-blocks')} className={'spice-block-side-margin'}>	
                    <RangeControl 
                        label={__('Horizontal Shadow(px)','spice-blocks')}			    
                        value={ hshadow}
                        onChange={(userVal) => setAttributes({ hshadow: userVal })}
                        min={0}
                        max={100}
                    />
                    <RangeControl 
                        label={__('Vertical Shadow(px)','spice-blocks')}			    
                        value={ vshadow} onChange={(userVal) => setAttributes({ vshadow: userVal })}
                        min={0}
                        max={100}
                    />	
                    <RangeControl 
                        label={__('Blur Shadow(px)','spice-blocks')}			    
                        value={ blurshadow}
                        onChange={(userVal) => setAttributes({ blurshadow: userVal })}
                        min={0}
                        max={100}
                    />
                    <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"}
                        title={__('Background & Color Settings','spice-block-plus')}
                        colorSettings={[
                            {
                                value: shadowColor,
                                onChange: (colors) => setAttributes({ shadowColor: colors }),
                                label: __('Box Shadow Color','spice-blocks')
                            },
                        ]}
                    />
                </PanelBody>
                
                <PanelBody initialOpen={false} title={__('Color Settings','spice-block-plus')}>
                    <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"}
                        title={__('Color Settings','spice-blocks')}
                        colorSettings={[
                            {
                                value: timelinebgColor,
                                onChange: (colors) => setAttributes({ timelinebgColor: colors }),
                                label: __('Items Background Color','spice-blocks')
                            },
                            {
                                value: titleColor,
                                onChange: (colors) => setAttributes({ titleColor: colors }),
                                label: __('Title Color','spice-blocks')
                            },
                            {
                                value: contentColor,
                                onChange: (colors) => setAttributes({ contentColor: colors }),
                                label: __('Content Color','spice-blocks')
                            },
                            {
                                value: yearbgColor,
                                onChange: (colors) => setAttributes({ yearbgColor: colors }),
                                label: __('Year Background','spice-blocks')
                            },
                            {
                                value: yearColor,
                                onChange: (colors) => setAttributes({ yearColor: colors }),
                                label: __('Year Color','spice-blocks')
                            },
                            {
                                value: timeColor,
                                onChange: (colors) => setAttributes({ timeColor: colors }),
                                label: __('Time Color','spice-blocks'),
                            },
                        ]}  
                    />
                </PanelBody>
                
                <PanelBody initialOpen={false} title={__('Typography Settings','spice-blocks')}>
                    <PanelBody initialOpen={false} title={__('Title Typography','spice-blocks')} className={'spice-block-side-margin'}>
                        <BaseControl id="spice-timeline-font-family" label={__(' Font Family','spice-blocks')}>
                            <FontPicker
                                apiKey="AIzaSyBH0F5UCzRyGQImf8sDK3UVo18kCeq_FqM"
                                activeFontFamily={ fontfamily }
                                limit={ 200 }
                                onChange={ ( userVal ) => setAttributes({fontfamily: userVal.family}) }
                            />
                        </BaseControl>
                        <FontSizePicker 
                            __nextHasNoMarginBottom
                            value={ titlefontSize }
                            onChange={(userVal) => setAttributes({titlefontSize: userVal})}
                        />
                        <SelectControl
                            label={__('Font Weight','spice-blocks')}
                            options= {[
                                { label: __('Thin','spice-blocks'), value: '100' },
                                { label: __('Extra Light','spice-blocks'), value: '200' },
                                { label: __('Light','spice-blocks'), value: '300' },
                                { label: __('Regular','spice-blocks'), value: '400' },
                                { label: __('Medium','spice-blocks'), value: '500' },
                                { label: __('Semi Bold','spice-blocks'), value: '600' },
                                { label: __('Bold','spice-blocks'), value: '700' },
                                { label: __('Extra Bold','spice-blocks'), value: '800' },
                                { label: __('Black','spice-blocks'), value: '900' }
                            ]}
                            value={TitleFontWeight}
                            onChange={ (userVal) => setAttributes({ TitleFontWeight: userVal }) }
                        />
                        <RangeControl 
                            label={__('line Height (px)','spice-blocks')}
                            value={TitleLineHeight}
                            min={0}
                            max={100}
                            onChange={(userVal) => setAttributes({TitleLineHeight: userVal})}
                        />
                        <SelectControl
                            label={__('Text Transform','spice-blocks')}
                            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                { label: __('Capitalize','spice-blocks'), value: 'capitalize' }
                            ]}
                            value={TitleTransform}
                            onChange={(userVal) => setAttributes({TitleTransform:userVal})}
                        />
                        <SelectControl 
                            label={__('Text Decoration','spice-blocks')}
                            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Underline','spice-blocks'), value: 'underline' },
                                { label: __('Overline','spice-blocks'), value: 'overline' },
                                { label: __('Line Through','spice-blocks'), value: 'line-through' }
                            ]}
                            value={TitleDecoration}
                            onChange={(userVal) => setAttributes({TitleDecoration:userVal})}
                        />
                        <RangeControl 
                            label={__('Letter Spacing (px)','spice-blocks')}
                            value={TitleLetterSpacing}
                            min={-10.0}
                            max={10.0}
                            onChange={(userVal)=> setAttributes({TitleLetterSpacing:userVal})}
                        />
                    </PanelBody>
                    <PanelBody initialOpen={false} title={__('Content Typography','spice-blocks')} className={'spice-block-side-margin'}>
                        <BaseControl label={__('Font Family','spice-blocks')}>
                            <FontPicker 
                                apiKey="AIzaSyBH0F5UCzRyGQImf8sDK3UVo18kCeq_FqM"
                                activeFontFamily={ TimelineContentfontfamily }
                                limit={ 200 }
                                onChange={ ( userVal ) => setAttributes({
                                    TimelineContentfontfamily: userVal.family
                                }) }
                                
                            />
                        </BaseControl>
                        <FontSizePicker 
                             __nextHasNoMarginBottom
                             value={TimelinecontentfontSize}
                             onChange={(userVal) => setAttributes({TimelinecontentfontSize: userVal})}
                        />
                        <SelectControl 
                            label={__('Font Weight','spice-blocks')}
                            options= {[
                                { label: __('Thin','spice-blocks'), value: '100' },
                                { label: __('Extra Light','spice-blocks'), value: '200' },
                                { label: __('Light','spice-blocks'), value: '300' },
                                { label: __('Regular','spice-blocks'), value: '400' },
                                { label: __('Medium','spice-blocks'), value: '500' },
                                { label: __('Semi Bold','spice-blocks'), value: '600' },
                                { label: __('Bold','spice-blocks'), value: '700' },
                                { label: __('Extra Bold','spice-blocks'), value: '800' },
                                { label: __('Black','spice-blocks'), value: '900' }
                            ]}
                            value={ TimelineContentFontWeight}
                            onChange={(userVal) => setAttributes({TimelineContentFontWeight: userVal})}
                        />
                        <RangeControl 
                            label={__('line Height (px)','spice-blocks')}
                            value={TimelineContentLineHeight}
                            min={0}
                            max={100}
                            onChange={(userVal)=> setAttributes({TimelineContentLineHeight:userVal})}
                        />
                        <SelectControl 
                            label={__('Text Transform','spice-blocks')}
                            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                { label: __('Capitalize','spice-blocks'), value: 'capitalize' }
                            ]}
                            value={TimelineContentTextTransform}
                            onChange={(userVal) => setAttributes({TimelineContentTextTransform: userVal})}
                        />
                        <SelectControl 
                            label={__('Text Decoration','spice-blocks')}
                            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Underline','spice-blocks'), value: 'underline' },
                                { label: __('Overline','spice-blocks'), value: 'overline' },
                                { label: __('Line Through','spice-blocks'), value: 'line-through' }
                            ]}
                            value={TimelineContentTextDecoration}
                            onChange={(userVal) => setAttributes({TimelineContentTextDecoration: userVal})} 
                        />
                        <RangeControl 
                            label={__('Letter Spacing  (px)','spice-blocks')}
                            value={TimelineContentLetterSpacing}
                            min={-10.0}
                            max={10.0}
                            onChange={(userVal) => setAttributes({TimelineContentLetterSpacing: userVal})}
                        />
                    </PanelBody>
                    <PanelBody initialOpen={false} title={__('Date/ Year Typography','spice-blocks')} className={'spice-block-side-margin'}>
                        <BaseControl label={__('Font Family','spice-blocks')}>
                            <FontPicker 
                                apiKey="AIzaSyBH0F5UCzRyGQImf8sDK3UVo18kCeq_FqM"
                                activeFontFamily={ TimelinDateFontFamily }
                                limit={ 200 }
                                onChange={ ( userVal ) => setAttributes({
			                        TimelinDateFontFamily: userVal.family
			                    }) }
                            />
                        </BaseControl>
                        <FontSizePicker 
                            __nextHasNoMarginBottom
				            value={ TimelineDateFontSize }
				            onChange={(userVal) => setAttributes({TimelineDateFontSize: userVal})}
				        />
                        <SelectControl 
                            label={__('Font Weight','spice-blocks')}
                            options= {[
                                { label: __('Thin','spice-blocks'), value: '100' },
                                { label: __('Extra Light','spice-blocks'), value: '200' },
                                { label: __('Light','spice-blocks'), value: '300' },
                                { label: __('Regular','spice-blocks'), value: '400' },
                                { label: __('Medium','spice-blocks'), value: '500' },
                                { label: __('Semi Bold','spice-blocks'), value: '600' },
                                { label: __('Bold','spice-blocks'), value: '700' },
                                { label: __('Extra Bold','spice-blocks'), value: '800' },
                                { label: __('Black','spice-blocks'), value: '900' }
                            ]}
                            value={TimelineDateFontWeight}
                            onChange={(userVal) => setAttributes({TimelineDateFontWeight: userVal})}
                        />
                        <RangeControl 
                            label={__('line Height (px)','spice-blocks')}
                            value={TimelineDateLineHeight}
                            min={0}
                            max={100}
                            onChange={(userVal) => setAttributes({TimelineDateLineHeight:userVal})}
                        />
                        <SelectControl 
                            label={__('Text Transform','spice-blocks')}
                            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                { label: __('Capitalize','spice-blocks'), value: 'capitalize' }
                            ]}
                            value={TimelineDateTextTransform}
                            onChange={(userVal) => setAttributes({TimelineDateTextTransform: userVal})}
                        />
                        <SelectControl 
                            label={__('Text Decoration','spice-blocks')}
                            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Underline','spice-blocks'), value: 'underline' },
                                { label: __('Overline','spice-blocks'), value: 'overline' },
                                { label: __('Line Through','spice-blocks'), value: 'line-through' }
                            ]}
                            value={TimelineDateTextDecoration}
                            onChange={(userVal) => setAttributes({TimelineDateTextDecoration: userVal})}
                        />
                        <RangeControl 
                            label={__('Letter Spacing  (px)','spice-blocks')}
                            value={TimelineDateLetterSpacing}
                            min={-10.0}
                            max={10.0}
                            onChange={(userVal) => setAttributes({TimelineDateLetterSpacing:userVal})}
                        />
                    </PanelBody>
                    <PanelBody initialOpen={false} title={__('Time Typography','spice-blocks')} className={'spice-block-side-margin'}>
                        <BaseControl label={__('FontFamily','spice-blocks')}>
                            <FontPicker
			                    apiKey="AIzaSyBH0F5UCzRyGQImf8sDK3UVo18kCeq_FqM"
			                    activeFontFamily={ TimelineTimeFontFamily }
			                    limit={ 200 }
			                    onChange={ ( userVal ) => setAttributes({
			                        TimelineTimeFontFamily: userVal.family
			                    }) }
			            	/>
                        </BaseControl>
                        <FontSizePicker 
                            __nextHasNoMarginBottom
				            value={ TimelineTimeFontSize }
				            onChange={(userVal) => setAttributes({TimelineTimeFontSize: userVal})}
				        />
                        <SelectControl
				            label={__('Font Weight','spice-blocks')}
				            value={ TimelineTimeFontWeight }
				            options= {[
                                { label: __('Thin','spice-blocks'), value: '100' },
                                { label: __('Extra Light','spice-blocks'), value: '200' },
                                { label: __('Light','spice-blocks'), value: '300' },
                                { label: __('Regular','spice-blocks'), value: '400' },
                                { label: __('Medium','spice-blocks'), value: '500' },
                                { label: __('Semi Bold','spice-blocks'), value: '600' },
                                { label: __('Bold','spice-blocks'), value: '700' },
                                { label: __('Extra Bold','spice-blocks'), value: '800' },
                                { label: __('Black','spice-blocks'), value: '900' }
                            ]}
				            onChange={ (newtext) => setAttributes({ TimelineTimeFontWeight: newtext }) }					  
				        />
                        <RangeControl 
							label={__('line Height (px)','spice-blocks')}			    
						    value={ TimelineTimeLineHeight}
				        	onChange={(newtext) => setAttributes({ TimelineTimeLineHeight: newtext })}
							min={0}
							max={100}
						/>
                        <SelectControl
				            label={__('Transform','spice-blocks')}
				            value={ TimelineTimeTransform }
				            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                { label: __('Capitalize','spice-blocks'), value: 'capitalize' }
                            ]}
				            onChange={ (newtext) => setAttributes({ TimelineTimeTransform: newtext }) }					  
			        	/>
				        <SelectControl
				            label={__('Decoration ','spice-blocks')}
				            value={ TimelineTimeDecoration }
				            options={[
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Underline','spice-blocks'), value: 'underline' },
                                { label: __('Overline','spice-blocks'), value: 'overline' },
                                { label: __('Line Through','spice-blocks'), value: 'line-through' }
                            ]}
				            onChange={ (newtext) => setAttributes({ TimelineTimeDecoration: newtext }) }					  
				        />
				        <RangeControl 
							label={__('Letter Spacing  (px)','spice-blocks')}			    
						    value={ TimelineTimeLetterSpacing}
				        	onChange={(newtext) => setAttributes({ TimelineTimeLetterSpacing: newtext })}
							min={-10.0}
							max={10.0}
						/>         
                    </PanelBody>
                </PanelBody>
            </InspectorControls>
            <style dangerouslySetInnerHTML={{
			  __html: [
			     `#block-${clientId} .timeline-block
                 {
                    padding: ${TimelineSectionOuterPaddings.top} ${TimelineSectionOuterPaddings.right ? TimelineSectionOuterPaddings.right: 0} ${TimelineSectionOuterPaddings.bottom} ${TimelineSectionOuterPaddings.left ? TimelineSectionOuterPaddings.left: 0};
                    animation-delay: ${TimelineDelay}ms;
                 }
                 #block-${clientId} .timeline-content .block-row .block-col-6 .info-box
                 {
                    background:${timelinebgColor};
                    padding: ${TimelineSectionInnerPaddings.top} ${TimelineSectionInnerPaddings.right} ${TimelineSectionInnerPaddings.bottom} ${TimelineSectionInnerPaddings.left};
                    box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                 }
                 #block-${clientId} .timeline-content .block-row .block-col-6 .info-box .year
                 {
                    background:${yearbgColor};
                    color:${yearColor};
                    font-family:${TimelinDateFontFamily ? TimelinDateFontFamily : 'Montserrat, sans-serif'};
                    font-size: ${TimelineDateFontSize};
                    font-weight: ${TimelineDateFontWeight};
                    line-height: ${TimelineDateLineHeight}px;
                    text-transform:${TimelineDateTextTransform};
                    text-decoration:${TimelineDateTextDecoration};
                    letter-spacing:${TimelineDateLetterSpacing}px;
                    padding:${TimelineYearPaddings.top} ${TimelineYearPaddings.right} ${TimelineYearPaddings.bottom} ${TimelineYearPaddings.left};
                 }
                 #block-${clientId} .timeline-content .block-row .block-col-6 .info-box h3
                 {
                    color:${titleColor};
                    font-family:${fontfamily ? fontfamily : 'Montserrat, sans-serif'};
                    font-size: ${titlefontSize};
                    font-weight: ${TitleFontWeight};
                    line-height: ${TitleLineHeight}px;
                    text-transform:${TitleTransform};
                    text-decoration:${TitleDecoration};
                    letter-spacing:${TitleLetterSpacing}px;
                    padding:${TimelineTitlePaddings.top} ${TimelineTitlePaddings.right} ${TimelineTitlePaddings.bottom} ${TimelineTitlePaddings.left};
                 }
                 #block-${clientId} .timeline-content .block-row .block-col-6 .info-box p
                 {
                    color:${contentColor};
                    font-family:${TimelineContentfontfamily ? TimelineContentfontfamily : 'Montserrat'};
                    font-size: ${TimelinecontentfontSize};
                    font-weight: ${TimelineContentFontWeight};
                    line-height: ${TimelineContentLineHeight}px;
                    text-transform:${TimelineContentTextTransform};
                    text-decoration:${TimelineContentTextDecoration};
                    letter-spacing:${TimelineContentLetterSpacing}px;
                    padding:${TimelineContentPaddings.top} ${TimelineContentPaddings.right} ${TimelineContentPaddings.bottom} ${TimelineContentPaddings.left};
                 }
                 #block-${clientId} .timeline-content .block-row .block-col-6 .timeline-time
                 {
                    color:${timeColor};
                    font-family:${TimelineTimeFontFamily ? TimelineTimeFontFamily : 'oswald'};
                    font-size: ${TimelineTimeFontSize};
                    font-weight: ${TimelineTimeFontWeight ? TimelineTimeFontWeight : 700};
                    line-height: ${TimelineTimeLineHeight}px;
                    text-transform:${TimelineTimeTransform};
                    text-decoration:${TimelineTimeDecoration};
                    letter-spacing:${TimelineTimeLetterSpacing}px;
                    padding:${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
                 }
                 #spice_blocks_plus_id_${uniqueId} .timeline .timeline-content::before{
                    border: ${TimelineConnectorCircle.width} ${TimelineConnectorCircle.style} ${TimelineConnectorCircle.color};
                    border-top:${TimelineConnectorCircleortop};
					border-right:${TimelineConnectorCircleright};
					border-bottom:${TimelineConnectorCirclebottom};
					border-left:${TimelineConnectorCircleleft};
                    width:${TimelineConnectorCircleSize}px;
                    height:${TimelineConnectorCircleSize}px;
                    background: #ffffff;
				}`,
                `#spice_blocks_plus_id_${uniqueId} .timeline-block-1 .block-container .timeline::before{
                    border: ${TimelineConnector.width} ${TimelineConnector.style} ${TimelineConnector.color};
                    border-top:${TimelineConnectortop};
					border-right:${TimelineConnectoright};
					border-bottom:${TimelineConnectorbottom};
					border-left:${TimelineConnectorleft};
                }`,
                `.editor-styles-wrapper .wp-block {
                   
                }`
			    ].join('\n')
			  }}>
			</style>
            </>,
            <>
            <div className={`timeline-block ${animationclass} ${displayclass}`} id={`spice_blocks_plus_id_${uniqueId}`}>
                <div class="timeline-block-1">
                    <div class="block-container">
                        <div class="timeline">
                            { attributes.items && attributes.items.map( (timeline,index) => (
                                <div className={`timeline-content ${hoverAnimation}`}>
                                    <button className="spice-timeline-button" onClick={() =>this.SpiceRemoveTimeline(index)}>
                                    <span className="dashicons dashicons-no"></span>
                                </button>
                                    { (index + 1) %2 !==0 ? 
                                    (
                                        <div class="block-row">
                                            <div class="block-col-6">
                                                <div class="info-box">
                                                    {enableTimelineYr === true && [
                                                    <RichText 
                                                        tagName="div"
                                                        className="year"
                                                        value={timeline.year}
                                                        onChange={(value) => this.SpiceOnLoadTimelineValue( 'year', value, index, true )}
                                                    />
                                                    ]}
                                                    <div class="info">
                                                        {enableTimelineTitle == true && [
                                                        <RichText 
                                                            tagName="h3"
                                                            value={timeline.title}
                                                            onChange={(value) => this.SpiceOnLoadTimelineValue( 'title', value, index, true )}
                                                        />]}
                                                        {enableTimelineContent === true && [
                                                        <RichText
                                                            tagName="p"
                                                            value={timeline.description}
                                                            onChange={(value) => this.SpiceOnLoadTimelineValue( 'description', value, index, true )}
                                                        />
                                                        ]}
                                                    </div>
                                                </div>   

                                            </div>

                                            <div class="block-col-6">
                                                { enableTimelineTime === true && [
                                                <div class="time">
                                                    <RichText 
                                                        tagName="div"
                                                        className="timeline-time"
                                                        value={timeline.dateTime}
                                                        onChange={(value) => this.SpiceOnLoadTimelineValue( 'dateTime', value, index, true )}
                                                    />
                                                </div>
                                                ]} 
                                            </div>
                                        </div> 
                                    ) 
                                    : 
                                    (
                                        <div class="block-row">
                                            <div class="block-col-6">
                                                { enableTimelineTime === true && [
                                                <div class="time">
                                                <RichText 
                                                    tagName="div"
                                                    className="timeline-time"
                                                    value={timeline.dateTime}
                                                    onChange={(value) => this.SpiceOnLoadTimelineValue( 'dateTime', value, index, true )}
                                                />
                                                </div>
                                                ]}
                                            </div>

                                            <div class="block-col-6">
                                            <div class="info-box" style={{background:`${timelinebgColor}`,padding:`${TimelineSectionInnerPaddings.top} ${TimelineSectionInnerPaddings.right} ${TimelineSectionInnerPaddings.bottom} ${TimelineSectionInnerPaddings.left}`}}>
                                                 { enableTimelineYr === true && [   
                                                <RichText 
                                                    tagName="div"
                                                    className="year"
                                                    value={timeline.year}
                                                    onChange={(value) => this.SpiceOnLoadTimelineValue( 'year', value, index, true )}
                                                />
                                                ]}
                                                    <div class="info">
                                                    { enableTimelineTitle === true && [    
                                                    <RichText 
                                                        tagName="h3"
                                                        value={timeline.title}
                                                        onChange={(value) => this.SpiceOnLoadTimelineValue( 'title', value, index, true )}
                                                    />
                                                    ]}
                                                    { enableTimelineContent === true && [
                                                    <RichText
                                                        tagName="p"
                                                        value={timeline.description}
                                                        onChange={(value) => this.SpiceOnLoadTimelineValue( 'description', value, index, true )}
                                                    />
                                                    ]}
                                                    </div>
                                                </div>  
                                            </div>
                                        </div>
                                    ) }
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
        <div><button className='spice-blocks-timeline-addbtn' onClick={this.SpiceAppendTimeline}>{__('Add New','spice-blocks')}</button></div>
            </div>
            </>
        ]);
    }
}

registerBlockType('spice-blocks/spice-timeline',{
    title: __('Timeline','spice-blocks'),
    category: 'spice-blocks',
    icon: <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <g>
        <g stroke="null" id="svg_23">
            <g stroke="null" transform="matrix(0.0471949 0 0 0.0466861 354.342 607.032)" id="svg_19">
            <path fill="#09A223" stroke="#09A223" fill-rule="nonzero" id="svg_20" d="m-7254.15769,-12793.50451c-11.502,0 -20.86,-9.357 -20.86,-20.86c0,-11.507 9.358,-20.87 20.86,-20.87c11.508,0 20.87,9.363 20.87,20.87c0,11.503 -9.362,20.86 -20.87,20.86m0,136.76c-11.502,0 -20.86,-9.363 -20.86,-20.87c0,-11.507 9.358,-20.87 20.86,-20.87c11.508,0 20.87,9.363 20.87,20.87c0,11.507 -9.362,20.87 -20.87,20.87m0,136.75c-11.502,0 -20.86,-9.358 -20.86,-20.86c0,-11.507 9.358,-20.871 20.86,-20.871c11.508,0 20.87,9.364 20.87,20.871c0,11.502 -9.362,20.86 -20.87,20.86m0,-452c11.508,0 20.87,9.362 20.87,20.87c0,11.508 -9.362,20.87 -20.87,20.87c-11.502,0 -20.86,-9.362 -20.86,-20.87c0,-11.508 9.358,-20.87 20.86,-20.87m50.87,20.87c0,-28.05 -22.82,-50.87 -50.87,-50.87c-28.044,0 -50.86,22.82 -50.86,50.87c0,22.829 15.114,42.192 35.86,48.61l0,39.54c-20.746,6.417 -35.86,25.781 -35.86,48.61c0,22.825 15.114,42.184 35.86,48.6l0,39.54c-20.746,6.417 -35.86,25.781 -35.86,48.61c0,22.829 15.114,42.192 35.86,48.61l0,39.54c-20.746,6.417 -35.86,25.78 -35.86,48.61c0,28.044 22.816,50.86 50.86,50.86c28.05,0 50.87,-22.816 50.87,-50.86c0,-22.831 -15.119,-42.195 -35.87,-48.611l0,-39.539c20.751,-6.416 35.87,-25.779 35.87,-48.61c0,-22.831 -15.119,-42.195 -35.87,-48.611l0,-39.538c20.751,-6.415 35.87,-25.775 35.87,-48.601c0,-22.831 -15.119,-42.195 -35.87,-48.611l0,-39.539c20.751,-6.416 35.87,-25.779 35.87,-48.61"/>
            </g>
            <g stroke="null" transform="matrix(0.0471949 0 0 0.0466861 354.342 607.032)" id="svg_17">
            <path fill="#09A223" stroke="#09A223" fill-rule="nonzero" id="svg_18" d="m-7369.93772,-12940.5185c-2.836,2.836 -6.605,4.397 -10.614,4.397l-79.18,0c-4.008,0 -7.77,-1.557 -10.613,-4.405c-2.829,-2.824 -4.387,-6.588 -4.387,-10.595c0,-4.006 1.558,-7.77 4.405,-10.612c2.825,-2.83 6.587,-4.388 10.595,-4.388l79.18,0c4.009,0 7.778,1.562 10.613,4.396c2.788,2.789 4.387,6.654 4.387,10.604c0,3.951 -1.599,7.816 -4.386,10.603m-10.614,-55.603l-79.18,0c-12.031,0 -23.333,4.685 -31.808,13.175c-8.507,8.492 -13.192,19.795 -13.192,31.825c0,12.031 4.685,23.333 13.174,31.808c8.493,8.508 19.795,13.192 31.826,13.192l79.18,0c12.021,0 23.324,-4.681 31.827,-13.184c8.495,-8.494 13.173,-19.794 13.173,-31.816c0,-12.021 -4.678,-23.321 -13.174,-31.817c-8.502,-8.501 -19.805,-13.183 -31.826,-13.183"/>
            </g>
            <g stroke="null" transform="matrix(0.0471949 0 0 0.0466861 354.342 607.032)" id="svg_15">
            <path fill="#09A223" stroke="#09A223" fill-rule="nonzero" id="svg_16" d="m-7369.93772,-12667.00649c-2.835,2.835 -6.605,4.396 -10.614,4.396l-79.18,0c-4.008,0 -7.77,-1.557 -10.613,-4.405c-2.829,-2.824 -4.387,-6.587 -4.387,-10.595c0,-4.006 1.558,-7.77 4.405,-10.612c2.825,-2.83 6.587,-4.388 10.595,-4.388l79.18,0c4.009,0 7.778,1.562 10.613,4.396c2.788,2.789 4.387,6.654 4.387,10.604c0,4.009 -1.558,7.776 -4.386,10.604m-10.614,-55.604l-79.18,0c-12.031,0 -23.333,4.685 -31.808,13.175c-8.507,8.492 -13.192,19.795 -13.192,31.825c0,12.031 4.685,23.333 13.174,31.808c8.492,8.508 19.795,13.192 31.826,13.192l79.18,0c12.022,0 23.324,-4.681 31.827,-13.183c8.495,-8.495 13.173,-19.794 13.173,-31.817c0,-12.021 -4.678,-23.321 -13.174,-31.817c-8.502,-8.501 -19.805,-13.183 -31.826,-13.183"/>
            </g>
            <g stroke="null" transform="matrix(0.0471949 0 0 0.0466861 354.342 607.032)" id="svg_13">
            <path fill="#09A223" stroke="#09A223" fill-rule="nonzero" id="svg_14" d="m-7137.38767,-12823.97254c2.799,-2.793 6.667,-4.396 10.612,-4.396l79.191,0c4.009,0 7.774,1.558 10.603,4.387c2.835,2.835 4.397,6.605 4.397,10.613c0,4.003 -1.562,7.769 -4.397,10.604c-2.794,2.794 -6.659,4.396 -10.603,4.396l-79.191,0c-3.939,0 -7.807,-1.606 -10.593,-4.386c-2.8,-2.806 -4.407,-6.674 -4.407,-10.614c0,-4.003 1.565,-7.776 4.388,-10.604m10.612,55.604l79.191,0c12.015,0 23.314,-4.681 31.817,-13.183c8.501,-8.502 13.183,-19.802 13.183,-31.817c0,-12.022 -4.682,-23.325 -13.184,-31.826c-8.495,-8.495 -19.794,-13.174 -31.816,-13.174l-79.191,0c-12.007,0 -23.303,4.675 -31.826,13.183c-8.495,8.511 -13.174,19.811 -13.174,31.817c0,12.001 4.679,23.297 13.194,31.828c8.509,8.494 19.805,13.172 31.806,13.172"/>
            </g>
            <g stroke="null" transform="matrix(0.0471949 0 0 0.0466861 354.342 607.032)" id="svg_11">
            <path fill="#09A223" stroke="#09A223" fill-rule="nonzero" id="svg_12" d="m-7037.97776,-12530.24648c-2.794,2.793 -6.659,4.396 -10.604,4.396l-79.19,0c-3.939,0 -7.808,-1.606 -10.594,-4.387c-2.8,-2.806 -4.406,-6.673 -4.406,-10.613c0,-4.003 1.565,-7.777 4.387,-10.604c2.799,-2.794 6.667,-4.396 10.613,-4.396l79.19,0c3.952,0 7.816,1.599 10.603,4.385c2.836,2.836 4.397,6.606 4.397,10.615c0,4.002 -1.561,7.768 -4.396,10.604m-10.604,-55.604l-79.19,0c-12.007,0 -23.303,4.674 -31.826,13.182c-8.495,8.512 -13.174,19.811 -13.174,31.818c0,12 4.679,23.297 13.192,31.826c8.511,8.495 19.807,13.174 31.808,13.174l79.19,0c12.016,0 23.316,-4.682 31.817,-13.183c8.502,-8.502 13.183,-19.801 13.183,-31.817c0,-12.021 -4.681,-23.324 -13.183,-31.828c-8.495,-8.494 -19.795,-13.172 -31.817,-13.172"/>
            </g>
            <g stroke="null" transform="matrix(0.0471949 0 0 0.0466861 354.342 607.032)" id="svg_9">
            <path fill="#09A223" stroke="#09A223" fill-rule="nonzero" id="svg_10" d="m-7350.54758,-12859.62452l-110.95,0c-8.284,0 -15,6.716 -15,15c0,8.284 6.716,15 15,15l110.95,0c8.284,0 15,-6.716 15,-15c0,-8.284 -6.716,-15 -15,-15"/>
            </g>
            <g stroke="null" transform="matrix(0.0471949 0 0 0.0466861 354.342 607.032)" id="svg_7">
            <path fill="#09A223" stroke="#09A223" fill-rule="nonzero" id="svg_8" d="m-7350.54758,-12799.1045l-49.59,0c-8.284,0 -15,6.715 -15,15c0,8.283 6.716,15 15,15l49.59,0c8.284,0 15,-6.717 15,-15c0,-8.285 -6.716,-15 -15,-15"/>
            </g>
            <g stroke="null" transform="matrix(0.0471949 0 0 0.0466861 354.342 607.032)" id="svg_5">
            <path fill="#09A223" stroke="#09A223" fill-rule="nonzero" id="svg_6" d="m-7156.77781,-12691.87452l110.96,0c8.284,0 15,-6.716 15,-15c0,-8.284 -6.716,-15 -15,-15l-110.96,0c-8.284,0 -15,6.716 -15,15c0,8.284 6.716,15 15,15"/>
            </g>
            <g stroke="null" transform="matrix(0.0471949 0 0 0.0466861 354.342 607.032)" id="svg_3">
            <path fill="#09A223" stroke="#09A223" fill-rule="nonzero" id="svg_4" d="m-7157.77781,-12632.3545l49.601,0c8.284,0 15,-6.717 15,-15c0,-8.285 -6.716,-15 -15,-15l-49.601,0c-8.284,0 -15,6.715 -15,15c0,8.283 6.716,15 15,15"/>
            </g>
        </g>
    </g>
    </svg>,
    keywords: [
        __('Timeline','spice-blocks'),
        __('Spice Timeline','spice-blocks')
    ],
    example: {
        attributes: {
            heading: __('TimeLine','spice-blocks')
        }
     },
    attributes: {
        uniqueId: {
            type: 'string'
        },
        items: {
            type: 'array',
            default:[]
        },
        isFirstLoad: {
            type: 'boolean',
            default: true
        },
        timeLineColor:
        {
            type: 'string'
        },
        hoverAnimation: {
            type: 'boolean',
            default: true
        },
        TimelineAnimation:{
            type:'string',
            default:''
         },
         TimelineDurations:{
            type:'string'
         },
         TimelineDelay:{
            type:'string'
         }, 
        enableTimelineTitle: {
            type: 'boolean',
            default: true
        },
        enableTimelineContent: {
            type: 'boolean',
            default: true
        },
        enableTimelineYr: {
            type: 'boolean',
            default: true
        },
        enableTimelineTime: {
            type: 'boolean',
            default: true
        },
        timelinebgColor: {
			type: 'string',
            default:'#ffffff'
		},
        titleColor: {
			type: 'string',
            default:'#333333'
		},
        contentColor: {
			type: 'string',
            default:'#777777'
		},
        yearbgColor: {
			type: 'string',
            default:'#7cc048'
		},
        yearColor: {
			type: 'string',
            default:'#ffffff'
		},
        timeColor: {
			type: 'string',
            default:'#000'
		},
        paddings: {
            default: {
                top: '0',
                right: '10px',
                bottom: '0',
                left: '10px'
            }
        },
        TimelineSectionOuterPaddings: {
            default: {
                top: '50px',
                right: '0',
                bottom: '50px',
                left: '0'
            }
        },
        TimelineSectionInnerPaddings: {
            default: {
                top: '4px',
                right: '10px',
                bottom: '14px',
                left: '0'
            }
        },
        TimelineTitlePaddings: {
            default: {
                top: '0',
                right: '0',
                bottom: '0',
                left: '0'
            }
        },
        TimelineContentPaddings: {
            default: {
                top: '0',
                right: '0',
                bottom: '0',
                left: '0'
            }
        },
        TimelineYearPaddings: {
            default: {
                top: '29px',
                right: '28px',
                bottom: '29px',
                left: '28px'
            }
        },
        fontfamily:{
	    	type:'string',
            default:'Montserrat'
	    },
        titlefontSize:
        {
            type:'string',
            default: '20px'
        },
        TitleFontWeight:{
			type:'string',
			default:'800'
		},
        TitleLineHeight:{
	    	type:'number',
	    	default:30
	    },
        TitleTransform:{
	    	type:'string'
	    },
        TitleDecoration:{
	    	type:'string'
	    },
        TitleLetterSpacing:{
	    	type:'number'
	    },
        TimelineContentfontfamily:{
	    	type:'string',
            default:'Montserrat'
	    },
        TimelinecontentfontSize:{
	    	type:'string',
	    	default:'16px'
	    },
        TimelineContentFontWeight:
        {
            type: 'string',
            default: 400
        },
        TimelineContentLineHeight:
        {
            type:'number',
            default:20
        },
        TimelineContentTextTransform:
        { 
            type:'string'
        },
        TimelineContentTextDecoration:
        {
            type:'string'
        },
        TimelineContentLetterSpacing:
        {
            type:'number'
        },
        TimelineDateLetterSpacing:
        {
            type:'number'
        },
        TimelineTimeLetterSpacing:
        {
            type:'number'
        },
        TimelinDateFontFamily:
        {
            type:'string',
            default:'Montserrat'
        },
        TimelineDateFontSize:
        {
            type:'string',
            default:'36px'
        },
        TimelineDateFontWeight:
        {
            type:'string',
            default:500
        },
        TimelineDateLineHeight:
        {
            type:'number',
            default:42
        },
        TimelineDateTextTransform:
        {
            type:'string',
        },
        TimelineTimeTransform:
        {
            type:'string',
        },
        TimelineDateTextDecoration:
        {
            type:'string'
        },
        TimelineTimeDecoration:
        {
            type:'string'
        },
        TimelineTimeFontFamily:
        {
            type:'string',
            default:'Montserrat'
        },
        TimelineTimeFontSize:{
	    	type:'string',
	    	default:'18px'
	    },
        TimelineTimeFontWeight:
        {
            type:'string',
            default:700
        },
        TimelineTimeLineHeight:
        {
            type:'number',
            default:28
        },
        TimelineHideDesktop:{
	    	type: 'boolean',
			default: true
	    },
	    TimelineHideTablet:{
	    	type: 'boolean',
			default: true
	    },
	    TimelineHideMobile:{
	    	type: 'boolean',
			default: true
	    },
        TimelineConnector: {
            default: {
                width: '1px',
                color: '#f7f6f6',
                style: 'solid'
            }
        },
        TimelineConnectorCircle: {
            default: {
                width: '5px',
                color: '#7cc048',
                style: 'solid'
            }
        },
        TimelineConnectorCircleSize:
        {
            type:'number',
            default:24
        },
        hshadow: {
            type: 'number',
            default: 0
        },
        vshadow: {
            type: 'number',
            default: 0
        },
        blurshadow: {
            type: 'number',
            default: 20
        },
        shadowColor:{
            type:'string',
            default:'#dedede'
        },
        
    },
    edit: (props) => {
        if(props.attributes.isFirstLoad)
        {
            props.setAttributes({
                items: [...JSON.parse( defaultTimeLine )],
                isFirstLoad: false,
                timeLineColor: '#FFA833'

            });
        } 
        return(<Edit {...props} />)
    },
    save: function( props ){
        const { className, attributes } = props;
        const { uniqueId, hoverAnimation, TimelineAnimation, TimelineDurations, TimelineDelay, enableTimelineTitle, enableTimelineContent, enableTimelineYr, enableTimelineTime, TimelineSectionOuterPaddings, TimelineSectionInnerPaddings, TimelineTitlePaddings, TimelineContentPaddings, TimelineYearPaddings,paddings, timelinebgColor, titleColor, contentColor, yearbgColor, yearColor, timeColor, fontfamily, titlefontSize, TitleFontWeight, TitleLineHeight, TitleTransform, TitleDecoration, TitleLetterSpacing, TimelineContentfontfamily, TimelinecontentfontSize, TimelineContentFontWeight, TimelineContentLineHeight, TimelineContentTextTransform, TimelineContentTextDecoration, TimelineContentLetterSpacing, TimelinDateFontFamily, TimelineDateFontSize, TimelineDateFontWeight, TimelineDateLineHeight, TimelineDateTextTransform, TimelineDateTextDecoration, TimelineDateLetterSpacing, TimelineTimeFontFamily, TimelineTimeFontSize, TimelineTimeFontWeight, TimelineTimeLineHeight, TimelineTimeTransform, TimelineTimeDecoration, TimelineTimeLetterSpacing, TimelineHideDesktop, TimelineHideTablet, TimelineHideMobile, TimelineConnector, TimelineConnectorCircle, TimelineConnectorCircleSize, hshadow, vshadow, blurshadow, shadowColor} = attributes;

        // Connector Line Border
        const TimelineConnectortop=(TimelineConnector.top != undefined) ? `${TimelineConnector.top.width} ${TimelineConnector.top.style} ${TimelineConnector.top.color}` : null;
	    const TimelineConnectoright=(TimelineConnector.right != undefined) ? `${TimelineConnector.right.width} ${TimelineConnector.right.style} ${TimelineConnector.right.color}` : null;
	    const TimelineConnectorbottom=(TimelineConnector.bottom != undefined) ? `${TimelineConnector.bottom.width} ${TimelineConnector.bottom.style} ${TimelineConnector.bottom.color}` : null;
	    const TimelineConnectorleft=(TimelineConnector.left != undefined) ? `${TimelineConnector.left.width} ${TimelineConnector.left.style} ${TimelineConnector.left.color}` : null;

        // Connector Circle Border
        const TimelineConnectorCircleortop=(TimelineConnectorCircle.top != undefined) ? `${TimelineConnectorCircle.top.width} ${TimelineConnectorCircle.top.style} ${TimelineConnectorCircle.top.color}` : null;
	    const TimelineConnectorCircleright=(TimelineConnectorCircle.right != undefined) ? `${TimelineConnectorCircle.right.width} ${TimelineConnectorCircle.right.style} ${TimelineConnectorCircle.right.color}` : null;
	    const TimelineConnectorCirclebottom=(TimelineConnectorCircle.bottom != undefined) ? `${TimelineConnectorCircle.bottom.width} ${TimelineConnectorCircle.bottom.style} ${TimelineConnectorCircle.bottom.color}` : null;
	    const TimelineConnectorCircleleft=(TimelineConnectorCircle.left != undefined) ? `${TimelineConnectorCircle.left.width} ${TimelineConnectorCircle.left.style} ${TimelineConnectorCircle.left.color}` : null;

        const animationclass='animated ' +attributes.TimelineDurations+' '+attributes.TimelineAnimation; 
        const displaydesktop=(TimelineHideDesktop == false) ? 'hide-desktop' : '';
        const displaytablet=(TimelineHideTablet == false) ? 'hide-tablet' : '';
        const displaymobile=(TimelineHideMobile == false) ? 'hide-mobile' : '';
        const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
        return(
            <>
            <script> 
				var fontfamily=`{fontfamily}`;
				var url2 = 'https://fonts.googleapis.com/css2?family='+fontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var link2 = document.createElement('link');
				link2.href = url2;
				link2.rel = "stylesheet";
				link2.type =  "text/css";	          
				document.head.appendChild(link2);

				
				var fontfamily2=`{TimelineContentfontfamily}`;				
				var fontfamilyurl2 = 'https://fonts.googleapis.com/css2?family='+fontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var fontfamilylink2 = document.createElement('link');
				fontfamilylink2.href = fontfamilyurl2;
				fontfamilylink2.rel = "stylesheet";
				fontfamilylink2.type =  "text/css";	          
				document.head.appendChild(fontfamilylink2);

                var fontfamily3=`{TimelinDateFontFamily}`;				
				var fontfamilyurl3 = 'https://fonts.googleapis.com/css2?family='+fontfamily3+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var fontfamilylink3 = document.createElement('link');
				fontfamilylink3.href = fontfamilyurl3;
				fontfamilylink3.rel = "stylesheet";
				fontfamilylink3.type =  "text/css";	          
				document.head.appendChild(fontfamilylink3);

                var fontfamily4=`{TimelineTimeFontFamily}`;				
				var fontfamilyurl4 = 'https://fonts.googleapis.com/css2?family='+fontfamily4+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var fontfamilylink4 = document.createElement('link');
				fontfamilylink4.href = fontfamilyurl4;
				fontfamilylink4.rel = "stylesheet";
				fontfamilylink4.type =  "text/css";	          
				document.head.appendChild(fontfamilylink4);
			</script>
            <style dangerouslySetInnerHTML={{
                __html: [
                `#spice_blocks_plus_id_${uniqueId}{
                    padding: ${TimelineSectionOuterPaddings.top} ${TimelineSectionOuterPaddings.right ? TimelineSectionOuterPaddings.right: 0} ${TimelineSectionOuterPaddings.bottom} ${TimelineSectionOuterPaddings.left ? TimelineSectionOuterPaddings.left: 0};
                    animation-delay: ${TimelineDelay}ms;
                 }
                 #spice_blocks_plus_id_${uniqueId} .timeline-content .block-row .block-col-6 .info-box
                 {
                    background:${timelinebgColor};
                    padding: ${TimelineSectionInnerPaddings.top} ${TimelineSectionInnerPaddings.right} ${TimelineSectionInnerPaddings.bottom} ${TimelineSectionInnerPaddings.left};
                    box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                 }
                 #spice_blocks_plus_id_${uniqueId} .timeline-content .block-row .block-col-6 .info-box .year
                 {
                    background:${yearbgColor};
                    color:${yearColor};
                    font-family:${TimelinDateFontFamily};
                    font-size: ${TimelineDateFontSize};
                    font-weight: ${TimelineDateFontWeight};
                    line-height: ${TimelineDateLineHeight}px;
                    text-transform:${TimelineDateTextTransform};
                    text-decoration:${TimelineDateTextDecoration};
                    letter-spacing:${TimelineDateLetterSpacing}px;
                    padding:${TimelineYearPaddings.top} ${TimelineYearPaddings.right} ${TimelineYearPaddings.bottom} ${TimelineYearPaddings.left};
                 }
                 #spice_blocks_plus_id_${uniqueId} .timeline-content .block-row .block-col-6 .info-box h3
                 {
                    color:${titleColor};
                    font-family:${fontfamily};
                    font-size: ${titlefontSize};
                    font-weight: ${TitleFontWeight};
                    line-height: ${TitleLineHeight}px;
                    text-transform:${TitleTransform};
                    text-decoration:${TitleDecoration};
                    letter-spacing:${TitleLetterSpacing}px;
                    padding:${TimelineTitlePaddings.top} ${TimelineTitlePaddings.right} ${TimelineTitlePaddings.bottom} ${TimelineTitlePaddings.left};
                 }
                 #spice_blocks_plus_id_${uniqueId} .timeline-content .block-row .block-col-6 .info-box p
                 {
                    color:${contentColor};
                    font-family:${TimelineContentfontfamily};
                    font-size: ${TimelinecontentfontSize};
                    font-weight: ${TimelineContentFontWeight};
                    line-height: ${TimelineContentLineHeight}px;
                    text-transform:${TimelineContentTextTransform};
                    text-decoration:${TimelineContentTextDecoration};
                    letter-spacing:${TimelineContentLetterSpacing}px;
                    padding:${TimelineContentPaddings.top} ${TimelineContentPaddings.right} ${TimelineContentPaddings.bottom} ${TimelineContentPaddings.left};
                 }
                 #spice_blocks_plus_id_${uniqueId} .timeline-content .block-row .block-col-6 .timeline-time
                 {
                    color:${timeColor};
                    font-family:${TimelineTimeFontFamily};
                    font-size: ${TimelineTimeFontSize};
                    font-weight: ${TimelineTimeFontWeight ? TimelineTimeFontWeight : 700};
                    line-height: ${TimelineTimeLineHeight}px;
                    text-transform:${TimelineTimeTransform};
                    text-decoration:${TimelineTimeDecoration};
                    letter-spacing:${TimelineTimeLetterSpacing}px;
                    padding:${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
                 }
                #spice_blocks_plus_id_${uniqueId} .timeline .timeline-content::before{
                        border: ${TimelineConnectorCircle.width} ${TimelineConnectorCircle.style} ${TimelineConnectorCircle.color};
                        border-top:${TimelineConnectorCircleortop};
                        border-right:${TimelineConnectorCircleright};
                        border-bottom:${TimelineConnectorCirclebottom};
                        border-left:${TimelineConnectorCircleleft};
                        width:${TimelineConnectorCircleSize}px;
                        height:${TimelineConnectorCircleSize}px;
                        background: #ffffff;
                        box-sizing: unset;
                    }`,
                `#spice_blocks_plus_id_${uniqueId} .timeline-block-1 .block-container .timeline::before{
                        border: ${TimelineConnector.width} ${TimelineConnector.style} ${TimelineConnector.color};
                        border-top:${TimelineConnectortop};
                        border-right:${TimelineConnectoright};
                        border-bottom:${TimelineConnectorbottom};
                        border-left:${TimelineConnectorleft};
                    }`
                  ].join('\n')
                }}>
            </style>
            <div className={`timeline-block ${animationclass} ${displayclass}`} id={`spice_blocks_plus_id_${uniqueId}`}>
                <div className={`timeline-block-1 ${attributes.className}`}>
                    <div class="block-container">
                        <div class="timeline">
                         { attributes.items && attributes.items.map((timeline,index) => (
                            <div className={`timeline-content ${hoverAnimation}`}>    
                                { (index + 1) %2 !==0 ? 
                                    (
                                        <div class="block-row">
                                        <div class="block-col-6">
                                            <div class="info-box">
                                                {enableTimelineYr === true && [
                                                <RichText.Content 
                                                    tagName="div"
                                                    className="year"
                                                    value={timeline.year}
                                                />
                                                ]}
                                                <div class="info">
                                                    {enableTimelineTitle ===true && [
                                                    <RichText.Content 
                                                        tagName="h3"
                                                        value={timeline.title}
                                                    />
                                                    ]}
                                                    {enableTimelineContent === true && [
                                                    <RichText.Content tagName="p" value={timeline.description}/>
                                                    ]}
                                                </div>
                                            </div>   
    
                                        </div>
    
                                        <div class="block-col-6">
                                            {enableTimelineTime === true && [
                                            <div class="time">
                                                <RichText.Content className="timeline-time" tagName="div" value={timeline.dateTime} />
                                            </div> 
                                            ]}
                                        </div>
                                    </div>
                                    ) 
                                    :
                                    (
                                        <div class="block-row">
                                        <div class="block-col-6">
                                            {enableTimelineTime === true && [
                                            <div class="time">
                                            <RichText.Content className="timeline-time" tagName="div" value={timeline.dateTime}/>
                                            </div>
                                            ]}
                                        </div>
    
                                        <div class="block-col-6">
                                        <div class="info-box">
                                            {enableTimelineYr === true && [    
                                            <RichText.Content tagName="div" className="year" value={timeline.year} />
                                            ]}
                                                <div class="info">
                                                    {enableTimelineTitle === true && [
                                                <RichText.Content tagName="h3" value={timeline.title}/>
                                                ]}
                                                {enableTimelineContent === true && [
                                                <RichText.Content tagName="p" value={timeline.description} />
                                                ]}
                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                    )}
                            </div>    
                         ))}
                        </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
});